import Layout from 'components/Layout';
import { Route, Routes, useLocation } from 'react-router-dom';
import GetStartedPage from './pages/GetStartedPage';
import GeneratedImageResult from './pages/GeneratedImageResult';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ImageStoreProvider } from 'components/ImageEditor/ImageEditorStoreProvider';
import UpscaleImageContextProvider from './provider';
import ObjectRemoverForm from './components/ObjectRemoverForm';
import { cn } from 'lib/utils';
import Questions from 'features/bot-builder/components/Common/Questions';
import { Apps } from 'constants/global';

export default function ObjectRemover() {
  const { pathname } = useLocation();

  const isResultPage = pathname === '/object-remover/result';

  return (
    <Layout>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}
      >
        <ImageStoreProvider>
          <UpscaleImageContextProvider>
            <div
              className={cn(
                'flex flex-col w-full h-full',
                isResultPage && 'flex-col lg:flex-row gap-3'
              )}
            >
              <Routes>
                <Route path="/get-started" element={<GetStartedPage />} />
                <Route path="/result" element={<GeneratedImageResult />} />
              </Routes>
              {isResultPage && <ObjectRemoverForm />}
              {!isResultPage && <Questions appType={Apps.OBJECT_REMOVER} />}
            </div>
          </UpscaleImageContextProvider>
        </ImageStoreProvider>
      </GoogleReCaptchaProvider>
    </Layout>
  );
}
